"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testingExport = exports.getMissingAgencyOptions = exports.getMissingProfessionalOptions = void 0;
const ConditionSatisfactionHelper_1 = require("../ConditionSatisfactionHelper");
const CalculateMissingOptionsHelpers_1 = require("./CalculateMissingOptionsHelpers");
function calculateMissingOptions(options) {
    const missingConditionOptions = [];
    const nonEmptyOptions = options.filter(({ qualifications }) => qualifications.length);
    nonEmptyOptions.forEach((option) => {
        const qualifications = option.qualifications;
        const humanizedQualifications = qualifications.map((optionQualification) => ({
            ...optionQualification.qualification,
            description: optionQualification.description,
        }));
        const willBeSatisfied = qualifications.every((optionQualification) => !optionQualification.isMissing);
        const qualificationToProfessionalQualification = (0, CalculateMissingOptionsHelpers_1.buildQualificationToProfessionalQualification)(qualifications);
        const remainingActionableQualifications = (0, CalculateMissingOptionsHelpers_1.buildRemainingActionableQualifications)(qualifications);
        missingConditionOptions.push({
            description: option.description,
            orCondition: option.orCondition,
            qualificationToProfessionalQualification,
            qualifications: humanizedQualifications,
            remainingActionableQualifications,
            willBeSatisfied,
        });
    });
    return missingConditionOptions;
}
;
// returns calculated missing options that are available for a professional to satisfy
const getMissingProfessionalOptions = ({ condition, professionalQualifications, satisfiedConditionIds, }) => {
    const conditionHelper = new ConditionSatisfactionHelper_1.ConditionSatisfactionHelper({
        condition,
        professionalQualifications,
        satisfiedConditionIds,
    });
    return calculateMissingOptions(conditionHelper.availableSatisfactionOptions);
};
exports.getMissingProfessionalOptions = getMissingProfessionalOptions;
// returns calculated missing options that are available for an agency to satisfy
const getMissingAgencyOptions = ({ condition, professionalQualifications, satisfiedConditionIds, }) => {
    const conditionHelper = new ConditionSatisfactionHelper_1.ConditionSatisfactionHelper({
        condition,
        professionalQualifications,
        satisfiedConditionIds,
    });
    return calculateMissingOptions(conditionHelper.availableAgencySatisfactionOptions);
};
exports.getMissingAgencyOptions = getMissingAgencyOptions;
exports.testingExport = {
    calculateMissingOptions,
};
